<template>
  <div id="page-forms">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <template>
            <v-card flat>
              <v-card-text>
                <v-toolbar color="white" dark flat dense cad>
                  <v-toolbar-title class="indigo--text"
                    >Datos de contacto</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-toolbar>
                <template>
                  <v-form>
                    <v-container>
                      <v-layout>
                        <v-flex>
                          <!-- INICIO DATOS DE CONTACTO -->
                          <data-contacto
                            :contactoId="id"
                            :tipeView="tipeView"
                            :tipeContact="tipeContact"
                          ></data-contacto>
                          <!-- TERMINO DATOS DE CONTACTO -->
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </template>
                <v-spacer></v-spacer>
              </v-card-text>
            </v-card>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DataContacto from "@/modules/configuration/contacto/views/ContactoData.vue";

export default {
  components: {
    DataContacto,
  },
  props: {},

  data() {
    return {
      id: "",
      tipeView: "",
      tipeContact: "",
    };
  },

  mounted: function () {},
  methods: {
    volver() {
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    },
  },
};
</script>
